import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { Api } from "../api";
import { Question } from "../../models/question.model";
import { Choice } from '../../models/choice.model';

@Injectable()
export class QuestionProvider extends Api {

  constructor(public http: HttpClient) {
    super(http);
  }

  getAllByQuizID(quizID: number): Observable<Question[]> {
    return this.http
      .get<Question[]>(`${this.url}/questions/quiz/${quizID}`)
      .map(response => {
        return response.map((question) => new Question(question));
      })
      .catch(this.handleError);
  }

  check(questionID: number): Observable<Choice[]> {
    return this.http
      .get<Choice[]>(`${this.url}/questions/check/${questionID}`)
      .map(choices => {
        return choices.map((choice) => new Choice(choice));
      })
      .catch(this.handleError);
  }

  sendAnswer(questionID: number, choices: Choice[]): Observable<Choice[]> {
    let headersConfig = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    return this.http
      .post(`${this.url}/questions/answer/${questionID}`, {
        choices: choices.map(choice => choice.id)
      }, {
        headers: headersConfig
      })
      .catch(this.handleError);
  }

}



// WEBPACK FOOTER //
// ./src/providers/question/question.ts